import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Styles } from "./styles/mobileMenu.js";
import { Constant } from "../../helper/Constants.js";

function MobileMenu() {
  const [navbarTexts, setNavbarTexts] = useState([]);
  const [showAbacus, setShowAbacus] = useState(false);

  useEffect(() => {
    // ===== FETCH MARQUEE TEXT =====
    axios
      .get(`${Constant.getUrls?.getAllNavbarTexts}?page=1&limit=20`)
      .then((resp) => {
        const rows = resp.data?.data || [];
        setNavbarTexts(
          rows.filter(
            (r) =>
              (r.is_delete || "no") !== "yes" &&
              (r.status || "active") === "active"
          )
        );
      })
      .catch(() => setNavbarTexts([]));

    // ===== TOGGLE MENU =====
    const openBtn = document.getElementById("mb-open");
    const closeBtn = document.getElementById("mb-close");
    const sidebar = document.getElementById("mb-sidebar");
    const overlay = document.getElementById("mb-overlay");

    openBtn.onclick = () => {
      sidebar.classList.add("open");
      overlay.classList.add("show");
    };

    closeBtn.onclick = overlay.onclick = () => {
      sidebar.classList.remove("open");
      overlay.classList.remove("show");
    };
  }, []);

  return (
    <Styles>
        {/* <div className="mobile-fixed-header"> */}

      {/* ================= TOP BAR ================= */}
      <div
        style={{
          background: "#29155E",
          padding: "6px 10px",
          display: "flex",
          alignItems: "center",
          gap: 8,
          width: "100%",
        }}
      >
        <a href="/franchise-enquiry" className="top-btn">
          Franchise
        </a>

        <div className="mobile-marquee">
          <div className="marquee-track">
            {navbarTexts.length
              ? navbarTexts.map((n, i) => <span key={i}>{n.title}</span>)
              : "Best Abacus Training • Franchise Available"}
          </div>
        </div>

        <a href="/abacus-school" className="top-btn">
          School Tie-Up
        </a>
      </div>

      {/* ================= LOGO BAR ================= */}
      <div
        style={{
          background: "#29155E",
          padding: "10px 14px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Link to="/">
          <img
            src="/assets/images/logo.png"
            alt="logo"
            style={{ height: 40 }}
          />
        </Link>

        <button id="mb-open" className="hamburger">
          ☰
        </button>
      </div>

      {/* ================= SIDEBAR ================= */}
      <div id="mb-sidebar" className="mobile-sidebar">
        <div className="sidebar-header">
          <img
            src="/assets/images/logo.png"
            alt="logo"
            style={{ height: 40 }}
          />
          <button id="mb-close" className="close-btn">
            ✕
          </button>
        </div>

        <nav className="sidebar-links">
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <div
            className="sidebar-dropdown"
            onClick={() => setShowAbacus(!showAbacus)}
          >
            <span>Abacus Classes</span>
            <span>{showAbacus ? "−" : "+"}</span>
          </div>

          {showAbacus && (
            <div className="sidebar-submenu">
              <Link to="/abacus-online">Abacus Online Classes</Link>
              <Link to="/abacus-near">Abacus Near Me</Link>
              <Link to="/abacus-school">Abacus School</Link>
            </div>
          )}

          <Link to="/course-grid">Courses</Link>
          <Link to="/events">Events</Link>
          <Link to="/blogs">Blogs</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/contact">Contact</Link>
        </nav>
      </div>

      {/* ================= OVERLAY ================= */}
      <div id="mb-overlay" className="mobile-overlay"></div>
        {/* </div> */}
    </Styles>
  );
}

export default MobileMenu;
